<template>
  <div class="container">
    <PageTitle class="mb-5">Profilo per Investitori</PageTitle>

    <div v-if="company && !company.visibleForInvestors" class="alert alert-info">
      <h1 class="h4 alert-heading">Clasusola contrattuale</h1>
      <p>
        Approvando la visualizzazione dei dati da parte degli investors si prende atto e si autorizza che i dati aziendali possano essere visibili ed utilizzabili da terzi, si dichiara inoltre di conoscere ed approvare esplicitamente le clausole denominate "Gli utenti Investitori" e "Responsabilità derivanti dall’utilizzo dei dati da parte di terzi autorizzati" del contratto.
      </p>
      <hr>
      <AwlConfirm status="primary" @confirm="enableCompany" title="Abilita">
        Rendere visibile l'azienda agli Investitori?
      </AwlConfirm>
    </div>
    <div v-else-if="company">
      <p>Per disabilitare la visualizzazione delle aziende, cliccare sul pulsante disabilita.</p>

      <AwlConfirm status="danger" @confirm="disableCompany" title="Disabilita">
        Nascondere l'azienda agli Investitori?
      </AwlConfirm>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    PageTitle: () => import('../../../components/Layout/LayoutOperative/PageTitle'),
    AwlConfirm: () => import('../../../../libs/Modals/components/AwlConfirm'),
  },
  data () {
    return {
      company: null,
    };
  },
  methods: {
    async enableCompany () {
      const { id } = this.$route.params;

      await this.$api.enableForInvestors(id);
      this.fetchCompany();
    },
    async disableCompany () {
      const { id } = this.$route.params;

      await this.$api.disableForInvestors(id);
      this.fetchCompany();
    },
    async fetchCompany () {
      const { id } = this.$route.params;

      try {
        const companyResponse = await this.$api.company(id);
        this.company = companyResponse.data;
      } catch (err) {
        this.$log.error(err);
      }
    },
  },
  mounted () {
    this.fetchCompany();
  },
};
</script>
